import { addQueryParameterToUrl } from './add-query-string-to-url'

export const getUploadSessionUrl = ({
	apiBaseUrl,
	language,
	feedType,
	country,
}: {
	apiBaseUrl: string
	language: string
	feedType: 'external' | 'internal'
	country?: string
}) => {
	return addQueryParameterToUrl({
		link: `${apiBaseUrl}/upload?mode=automatic&quarantine=yes&document_type=cv&extension=pdf&language=${language}`,
		queryParams: [
			['feed_type', feedType === 'internal' ? 'internal' : undefined],
			['country', country],
		],
	})
}
